export default __webpack_public_path__ + "static/media/rep.c3da7227.svg";